import { z } from "zod";
import { zStringId } from "../../utils";

export const zServicePackageExtraServices = z.array(
  z.object({
    name: z.string(),
    included: z.boolean(),
  }),
);

export const zServicePackage = z.object({
  _id: zStringId(),
  enabled: z.boolean(),
  name: z.string(),
  deliverables: z.string().optional(),
  description: z.string(),
  revisions: z.string(),
  extraServices: zServicePackageExtraServices,
  requiredDays: z.number(),
  requiredTime: z.object({
    count: z.number(),
    countType: z.enum(["DAYS", "WEEKS", "MONTHS"]),
  }),
  price: z.number(),
});

export type ServicePackage = z.infer<typeof zServicePackage>;
